import React from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {closeDeleteModalTriggers, deleteTrigger} from "../../redux-store/triggers";
import {deleteItemTriggerConfirmation} from "../../redux-store/selectors";

const ConfirmationDeleteTrigger = ({installationId,eventKey}) => {
    const modalDeleteStatus = useSelector(deleteItemTriggerConfirmation)

    const dispatch = useDispatch();

    const handleCloseModal = () => {
        dispatch(closeDeleteModalTriggers())
    }

    const handleDeleteItem = () => {
        dispatch(deleteTrigger({installationId:installationId, triggerItemId:eventKey}))
        dispatch(closeDeleteModalTriggers())
    }

    return (
        <Modal
            show={modalDeleteStatus}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati ovaj okidač?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={handleDeleteItem}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationDeleteTrigger;
